import componentMap from "./report-field.config.js";

import {
	boolField,
	checkboxField
} from "./field-types/boolAndCheckbox/boolAndCheckbox.js";
import dateTime from "./field-types/date-time/date-time.js";
import timeField from "./field-types/time/time.js";
import date from "./field-types/date/date.js";
import number from "./field-types/number/number.js";
import selection from "./field-types/selection/selection.js";
import simpleSelection from "./field-types/simple-selection/simple-selection.js";
import preSelect from "./field-types/pre-select/pre-select.js";
import entityContactSelector from "./field-types/entity-contact-selector/entity-contact-selector.js";
import multiSelect from "./field-types/multi-select/multi-select.js";
import text from "./field-types/text/text.js";
import textarea from "./field-types/text-area/textarea.js";
import fileUpload from "./field-types/file-upload/file-upload.js";
import imageUpload from "./field-types/image-upload/image-upload.js";
import degreeMinute from "./field-types/degree-minute/degree-minute.js";
import coordinate from "./field-types/coordinate/coordinate.js";
import yearMonth from "./field-types/year-month/year-month.js";
import markdown from "./field-types/markdown/markdown.js";
import readOnlyText from "./field-types/read-only-text/read-only-text.js";
import stringMulti from "./field-types/string-multi/string-multi.js";

import degreeMinuteField from "./field-sub-components/degree-minute-field/degree-minute-field.js";
import numberField from "./field-sub-components/number-field/number-field.js";

// report-form-field
function controller(
	$scope,
	$element,
	$logger,
	dynamicComponent
) {
	const ctrl = this;

	ctrl.$postLink = postLink;

	function postLink() {
		compile();
	}

	function compile() {
		const baseFieldSettings = componentMap[ctrl.field.Template] || componentMap["default"];
		const fieldSettings = ctrl.pivoter && baseFieldSettings.pivotAs
			? componentMap[baseFieldSettings.pivotAs]
			: baseFieldSettings;

		if(fieldSettings === componentMap["default"]) {
			$logger.error("Unable to find template for field", { field: ctrl.field.Name, template: ctrl.field.Template });
		}
		
		const locals = {
			fieldSettings: ctrl.field,
			values: ctrl.values,
			repeatId: ctrl.repeatId,
			pivotRow: ctrl.pivotRow,
			pivotColumn: ctrl.pivotColumn,
			setFieldDirty: ctrl.setFieldDirty
		};
		const context = ctrl.field;

		dynamicComponent.compile(
			fieldSettings,
			locals,
			$scope.$new(),
			$element,
			context
		);
	}
}

const deps = [
	boolField,
	checkboxField,
	date,
	dateTime,
	timeField,
	number,
	selection,
	entityContactSelector,
	simpleSelection,
	multiSelect,
	text,
	fileUpload,
	imageUpload,
	degreeMinute,
	preSelect,
	textarea,
	degreeMinuteField,
	coordinate,
	numberField,
	yearMonth,
	markdown,
	readOnlyText,
	stringMulti
];

export default angular
	.module("vesl.components.report-form-field", deps)
	.component("reportFormField", {
		controller,
		bindings: {
			field: "<",
			values: "<",
			repeatId: "<",
			pivotRow: "=",
			pivotColumn: "=",
			pivoter: "<",
			setFieldDirty: "="
		}
	}).name;
